<lazy-echart class="chart" [class.chart--fixed-height]="hasFixedHeight"
    [options]="chartOptions">
</lazy-echart>
